import Debtor from '@/views/debtor/Add.vue'

const router = {
    path: '/debtors/edit/:debtorId',
    name: 'DebtorEdit',
    component: Debtor,
    meta: {
        title: 'Edit Debtor'
    }
  };

export default router
